import axios from 'axios';

const env_resource_server = process.env.REACT_APP_RESOURCE_SERVER;
const instance = axios.create({
// .. where we make our configurations
    baseURL: `${env_resource_server}`
});

export { instance };